import { render } from "./CloseDialog.vue?vue&type=template&id=3699b3a4&scoped=true"
import script from "./CloseDialog.vue?vue&type=script&lang=js"
export * from "./CloseDialog.vue?vue&type=script&lang=js"

import "./CloseDialog.vue?vue&type=style&index=0&id=3699b3a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3699b3a4"]])

export default __exports__